import React, { useEffect, useMemo, useState } from 'react'
import './index.less'
import { Button, Checkbox, Col, Drawer, Form, List, message, Row, Space, Typography } from 'antd'
import { LeftOutlined, PlusCircleOutlined } from '@ant-design/icons'
import Flex from '../Flex'
import { getQueryStringValue } from '@/utils'
import ExperPorts from '../ExperPorts'
import Container from './Container'
import shellImg from '../../assets/images/toolsImg/shell.png'
import { name } from 'pubsub-js'

type ExperEnvPortManageProps = {
    open: boolean
    onClose: () => void
    modal: string
    onSave?: (data: any, defaultOpen: number) => Promise<any> // 保存接口  保存成功会关闭窗口
    setCurrentDefault: (port: number) => void, //设置默认打开工具端口
    currentDefault: number       //默认打开工具端口
    section: any
    getList: () => Promise<any> // 获取列表
}

// 步骤枚举类
// base 主页面   env 选择环境页面  port  添加端口
export enum StepEnum {
    BASE = 'BASE',
    PORT = 'PORT'
}
// 步骤类型
export type stepType = keyof typeof StepEnum

export enum UserType {
    SYSTEM = 'system',         // 系统
    CREATOR = 'creator',       // 创作者
    LEARNER = 'learner'        // 学习者
}

const ExperEnvPortManage: React.FC<ExperEnvPortManageProps> = (props) => {

    //Pod.yaml路径
    const location = getQueryStringValue("location")

    const { open, onClose, modal, onSave, getList, section, currentDefault, setCurrentDefault } = props
    const [form] = Form.useForm()
    const [step, setStep] = useState<stepType>(StepEnum.BASE)                         // 当前更新步骤
    const [loading, setLoading] = useState(false)                                     // 保存loading
    const [formData, setFormData] = useState<any>()                                   // 临时保存的数据
    const [initPort, setInitPort] = useState<any>()                                   // 初始化端口

    const ports = Form.useWatch('ports', form)

    const portCreatorNum = useMemo(() => {
        const res = ports?.filter((item: any) => modal === '1' ? item?.type === UserType.CREATOR : item?.type === UserType.LEARNER) || []
        return res?.length ?? 0
    }, [ports, modal])

    // 3 获取环境列表
    useEffect(() => {
        if (open) {
            fetchList()
        }
    }, [open])


    // 计算标题
    const title = useMemo(() => {
        let title
        if (step === StepEnum.BASE) {
            title = '端口管理'
        } else {
            title = `${initPort ? '编辑' : '添加'}端口`
        }
        return title!
    }, [step, initPort])

    // 上一步或取消
    const prev = (cancel: boolean) => {
        if (cancel) {
            onClose()
            return
        }
        changeStep(StepEnum.BASE)
        setInitPort(null)
    }

    // 保存退出弹框  保存环境  保存端口设置
    const save = async () => {
        const data = await form.validateFields().catch(() => { })
        if (data == undefined) return
        setLoading(true)
        if (step === StepEnum.BASE) {
            await saveExit(data)
        } else if (step === StepEnum.PORT) {
            await savePort(data)
        }
        setLoading(false)
    }
    // 保存退出
    const saveExit = async (data: any) => {
        setLoading(true)
        await onSave?.(data.ports.slice(1), currentDefault)
        setLoading(false)

    }

    // 保存端口
    const savePort = async (data: any) => {
        data.port = Number(data?.port)
        const port = data?.port
        if (formData?.ports?.some((item: any) => item?.port !== initPort?.port && item?.port === port)) {
            message.destroy()
            message.warning('端口重复')
            return
        }
        if (initPort) {
            const res = { ...initPort, ...data }
            const ports = formData?.ports?.map((item: any) => {
                if (item?.port === initPort?.port) {
                    return { ...item, ...res }
                }
                return { ...item }
            })
            setFormData({ ...formData, ports })
        } else {
            const port = {
                ...data,
                id: data?.port,
                name: data.name,
                port: parseInt(data.port),
                image: data.image,
                choice: true,
                isUse:true,
                type: modal === '1' ? UserType.CREATOR : UserType.LEARNER
            }
            const ports = formData?.ports?.concat([port]) ?? [port]
            setFormData({ ...formData, ports })
        }
        changeStep(StepEnum.BASE)
        setInitPort(null)
    }

    // 改变当前步骤
    const changeStep = (next: StepEnum) => {
        // 跳转到其他步骤优先保存
        if (step === StepEnum.BASE) {
            const data = form.getFieldsValue()
            setFormData(data)
        }
        setStep(next)
    }


    // 更新端口
    const updatePort = (type: 'update' | 'add', value?: any) => {
        if (type === 'update') {
            setInitPort(value)
        }
        changeStep(StepEnum.PORT)
    }

    // 请求列表
    const fetchList = async () => {
        const shell = {
            image: shellImg,
            port: 0,
            name: 'shell',
            // checked: true,
            // edited: false,
            // defaultOpen={true}
            // modal={modal === '1' ? true : false}
            // setCurrentDefault={setCurrentDefault}
            // currentDefault={currentDefault}
            // defaultCheck={currentDefault === 0}
        }
        //预览博客
        if (location) {
            setFormData({ ports: [shell, ...section?.template?.ports] })
            return
        }
        const res = await getList()
        if (!res?.some((item: any) => item?.port === currentDefault)) {
            setCurrentDefault(currentDefault === 0 ? 0 : -1)
        }
        setFormData({ ports: [shell, ...res] })
    }


    return (
        <Drawer
            placement='right'
            closable={false}
            destroyOnClose
            onClose={onClose}
            open={open}
            width={712}
            maskClosable={false}
            rootClassName='ExperEnvPortManage'
        >
            <Flex justify='space-between' align='center' style={{ height: '48px', borderBottom: '1px solid #E5E5E5', padding: '0 30px' }}>
                <span>
                    {
                        step !== StepEnum.BASE && <LeftOutlined onClick={() => { changeStep(StepEnum.BASE) }} style={{ color: '#999999', fontSize: '16px' }} />
                    }
                </span>
                <span style={{ color: '#333333', fontSize: '16px', fontWeight: 'bold' }}>{title}</span>
                <span>
                </span>
            </Flex>

            <div className='ExperEnvPortManage-content'>
                <Form
                    form={form}
                    colon={false}
                    autoComplete="off"
                    style={{ height: '100%' }}
                >
                    {
                        step === StepEnum.BASE ? <Container formData={formData} updatePort={updatePort} portCreatorNum={portCreatorNum} modal={modal} currentDefault={currentDefault} setCurrentDefault={setCurrentDefault}/> :
                            step === StepEnum.PORT ? <ExperPorts initValue={initPort} /> :
                                <></>
                    }
                </Form>
            </div>

            <Flex gap={20} justify='center' align='center' style={{ height: '72px' }}>
                <Button onClick={() => { prev(step === StepEnum.BASE) }}>{step === StepEnum.BASE ? '取消' : '上一步'}</Button>
                <Button loading={loading} type='primary' onClick={save}>保存</Button>
            </Flex>
        </Drawer>
    )
}

export default ExperEnvPortManage